import { Locale, type LocalizedString } from "../schema/Locale.js";
import { getExpectedAppSyncError } from "./aws/appsync/getExpectedAppSyncError.js";
import { getExpectedCognitoError } from "./aws/cognito/getExpectedCognitoError.js";

const generalExpectedByMessage: Record<string, LocalizedString> = {
	"Failed to fetch": {
		[Locale.cs]: "Nastala chyba s připojením. Ujistěte se, prosím, že máte stabilní připojení k internetu.",
		[Locale.en]: "An error with the network occurred. Please ensure that you have a stable internet connection.",
	},
};

const generalExpectedByName: Record<string, LocalizedString> = {
	FailedToFetchAfterRetries: {
		[Locale.cs]:
			"Nastala chyba s připojením i po několika pokusech. Ujistěte se, prosím, že máte stabilní připojení k internetu.",
		[Locale.en]:
			"An error with the connection has happened after multiple tries. Please ensure that you have a stable internet connection.",
	},
};

export function getExpectedError(error: unknown, locale: Locale, fallback?: string): string | undefined {
	const appsyncError = getExpectedAppSyncError(error, locale);
	if (appsyncError) {
		return appsyncError;
	}

	const cognitoError = getExpectedCognitoError(error, locale);
	if (cognitoError) {
		return cognitoError;
	}

	if (!(error instanceof Error)) {
		return fallback;
	}

	const expectedByName = generalExpectedByName[error.name];
	if (expectedByName) {
		return expectedByName[locale];
	}

	const expectedByMessage = generalExpectedByMessage[error.message];
	if (expectedByMessage) {
		return expectedByMessage[locale];
	}

	return undefined;
}
